export default "__VITE_ASSET__CSj_vm3t__"